<template>
  <trays-mobile-card
    v-if="mobileView"
    :studentTrays="studentTrays"
    :loadingData="loadingData"
    :errorRequest="errorRequest"/>
  <trays-default-list
    v-else
    :studentTrays="studentTrays"
    :loadingData="loadingData"
    :errorRequest="errorRequest"/>
</template>

<script>
import TraysMobileCard from './TraysMobileCard'
import TraysDefaultList from './TraysDefaultList'
import { mobileViewBreakpoint } from '@/helpers/mobileViewBreakpoint'

/**
 * @group Meal Control
 * Componente principal que controla a vizualização das bandejas
 * dos estudantes. Tem por principal função controlar qual o tipo
 * de view(mobile ou desktop) que será utilizado, subdividindo-se
 * entre os componentes [TraysDefaultList](/components/TraysDefaultList)
 * (desktop) e [TraysMobileCard](/components/TraysMobileCard)(mobile).
 */
export default {
  name: 'MealCard',

  components: {
    TraysMobileCard,
    TraysDefaultList
  },

  props: {
    // Controla o status de erro ao buscar informações
    errorRequest: {
      type: Boolean,
      default: false
    },
    // Controla o status de carregamento de informações
    loadingData: {
      type: Boolean,
      default: false
    },

    // Lista das bandejas dos estudantes
    studentTrays: {
      type: Array,
      // []
      default () { return [] }
    }
  },

  computed: {
    mobileView () {
      return mobileViewBreakpoint(this.$vuetify.breakpoint.name)
    }
  }
}
</script>
